export const RowType = {
    HEADER: 1,
    TOTALS: 2,
    FIRST_LEVEL: 3,
    SECOND_LEVEL: 4,
    THIRD_LEVEL: 5,
    FORTH_LEVEL: 6
}


// WEBPACK FOOTER //
// ./web/js/reports/table/RowType.js